import React from "react";

export default function CreateBy() {
  return (
    <div className="mt-3">
      <small>
        This project was coded by Yuliia Mustafina and{" "}
        <a
          href="https://github.com/Mustafina1990/weather-app"
          target="_blank"
          rel="noreferrer"
        >
          is open-source on GitHub
        </a>
      </small>
    </div>
  );
}
